import Task from "../task"
import Moment from "moment"
import DatetimeUtils from "../../../gd/utils/datetime-utils"
import {toMomentDate} from "../../../gd/convert/moment-date"
import {TaskProperties} from "../properties/properties"
import TimeReportsCollection from "../../time-report/collection";
import TimeReport from "../../time-report/time-report";
import EntityCollection from "../../entities-collection/entities-collection";
import {ProjectItemOrigin} from "../../project-item/@type"
import {ProjectItem} from "../../project-item/project-item"

// const debug = "applyTaskDelta"
const debug = false

export function taskIsSameValue(task:Task, paramName:string, value:any) {
    // @ts-ignore
    if (Moment.isMoment(task[paramName])) {
        // @ts-ignore
        return DatetimeUtils.isSame(task[paramName], DatetimeUtils.dateToMoment(value), 'day')
    } else {
        // @ts-ignore
        return _.isEqual(task[paramName], value)
    }
}

export function applyTaskDelta(task:Task, data:any) {

    let isChanged : boolean = false

    const ignoredParamsForIsChangedState = [
        'latestActivityDate',
        'latestActivityMoment',
        'recentActivityMoment',
        'dateCreated',
    ]

    _.mapKeys(data, (value ,key)=>{
        if (key === 'id') return;

        debug && console.log(debug, "mapKeys", "key=", key, "value=", value)

        const updateParamsNames = []

        // this block for renames
        switch (key) {
            case 'latestActivityMoment':
            case 'latestActivityDate':
            case 'recentActivityMoment':
                updateParamsNames.push('latestActivityMoment')
                break

            case 'actionRequiredSinceDate'      : /*skip*/ break


            case 'taskStatusId'                 : updateParamsNames.push('statusId'); break
            case 'systemStatusId'               : updateParamsNames.push('systemStatus'); break
            case 'projectId'                    :
                // updateParamsNames.push('parentId');  - was enabled in table old
                updateParamsNames.push('projectId');
                break

            case 'taskRecurrencyParentTaskId'   :
            case 'taskRecurrencyDate'           : isChanged = task._applyRecurrencyDelta(key, value); break

            case 'description'                  : updateParamsNames.push('descriptionTxt'); break
            case 'checklist'                    : updateParamsNames.push('todoList'); break

            default:
                updateParamsNames.push(key)
                break
        }

        debug && console.log(debug, "applyDelta updateParamsNames=", updateParamsNames)
        _.map(updateParamsNames, paramName=>{
            switch (paramName) {
                case 'scheduleDate'             :
                case 'deadline'                 :
                case 'startDate'                :
                case 'endDate'                  :
                    if (!taskIsSameValue(task, paramName, value)) {

                        // OLD
                        // task[paramName] = Moment.isMoment(value) ? value : DatetimeUtils.dateToMoment(value)

                        // patched to support gantt IT ALWAYS CREATE A COPY OF OBJECT
                        task[paramName] = toMomentDate(value)
                        if (!ignoredParamsForIsChangedState.includes(paramName)) isChanged = true
                    }
                    break

                case 'latestActivityMoment':
                    if (!taskIsSameValue(task, paramName, value)) {
                        task[paramName] = DatetimeUtils.datetimeToMoment(value)
                        if (!ignoredParamsForIsChangedState.includes(paramName)) isChanged = true
                    }
                    break


                case 'actionRequiredSinceDate'  :
                    if (!taskIsSameValue(task, paramName, value)) {
                        task[paramName] = Moment.isMoment(value) ? value : DatetimeUtils.datetimeToMoment(value)
                        if (!ignoredParamsForIsChangedState.includes(paramName)) isChanged = true
                    }
                    break

                // add to tak model
                case 'momentClosed':
                    if (!taskIsSameValue(task, paramName, value)) {
                        task[paramName] = Moment.isMoment(value) ? value : DatetimeUtils.datetimeToMoment(value)
                        if (!ignoredParamsForIsChangedState.includes(paramName)) isChanged = true
                    }
                    break

                case 'properties':
                    // task.properties = new TaskProperties(data['properties'])
                    task.properties = data['properties'] // Nelzya v setter peredat noviy instance. Vnutri setter sozdaetsya instance
                    if (!ignoredParamsForIsChangedState.includes(paramName)) isChanged = true
                    break

                case 'todoList':
                    debug && console.log(debug, "applyDelta paramName=", paramName, !_.isEqual(task.todoList?.toJSON(),value), task.todoList, value)

                    if (!_.isEqual(task.todoList?.toJSON(),value)) {
                        task.todoList?.reset(value)
                        isChanged = true
                    }
                    break

                case 'timeReports':

                    if (!task.timeReports) {
                        task.timeReports = TimeReportsCollection.initFromJson([])
                    }

                    debug && console.log(debug, "applyDelta paramName=", paramName, !_.isEqual(task.timeReports.toJSON(),value), task.timeReports, value)

                    if (!_.isEqual(task.timeReports.toJSON(),value)) {
                        task.timeReports.reset(_.map(value, record=>new TimeReport(record)))
                        isChanged = true

                        if (gd.ac.check.company.isManager()) {
                            task.resetCostFields()
                            // task.costInternal = task.timeReports.costInternal
                            // task.costExternal = task.timeReports.costExternal

                            debug && console.log(debug, "applyDelta cost", task.costInternal, task.costExternal)
                        }
                    }



                    break

                case 'successors':
                    task.successors = new EntityCollection()
                    task.successors.addTasksFromJson(value)
                    isChanged = true
                    break

                case 'predecessors':
                    task.predecessors = new EntityCollection()
                    task.predecessors.addTasksFromJson(value)
                    isChanged = true
                    break

                case 'projects': {
                    const newProjects = _.map(value, (data: any) => {
                        return new ProjectItem(data, task)
                    })

                    if (!taskIsSameValue(task, 'projects', newProjects)) {
                        task.projects = newProjects
                        isChanged = true
                    }
                } break

                // temporary for Live backend compatibility (should be removed when tasks multi-project backed is uploaded)
                case 'projectId':
                    if (!taskIsSameValue(task, 'projectId', value)) {
                        task.projectId = value
                        isChanged = true

                        // the new main project may already be linked - one entry per project
                        _.remove(task.projects, (projectItem: ProjectItem) => {
                            return projectItem.origin === ProjectItemOrigin.MAIN
                                || projectItem.projectId === value
                        })

                        task.projects.push(new ProjectItem({
                            projectId       : value,
                            origin          : ProjectItemOrigin.MAIN,
                            sortPosition    : data.sortPosition || task.sortPosition || 0
                        }, task))
                        task.resetProjectsMap()
                    }
                    break

                default                         :
                    debug && console.log(debug, "applyDelta paramName=", paramName, !taskIsSameValue(task, paramName, value), _.get(task,paramName), value)

                    if (!taskIsSameValue(task, paramName, value)) {
                        // @ts-ignore
                        task[paramName] = value;
                        if (!ignoredParamsForIsChangedState.includes(paramName)) isChanged = true
                    }
            }
        })
    });

    debug && console.log(debug, "applyDelta isChanged", isChanged, task)

    // eto uze ne nuzno...
    // task.updateMyWorkFields()

    return isChanged


}
